<template>
  <div class="page-add-user">
    <p class="addText">系统设置</p>
    <el-form
      :label-position="labelPosition"
      label-width="180px"
      :model="formData"
      style="width: 400px"
      ref="formData"
    >
      <div v-if="!isCompany">
        <el-form-item label="每日最大预约次数">
          <el-input
            v-model="formData.appointmentTimes"
            placeholder="请输入"
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item label="订单险价格">
          <el-input
            v-model="formData.order_insurance"
            placeholder="请输入"
            type="number"
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item label="最低价">
          <el-input
            v-model="formData.lowest_price"
            placeholder="请输入"
            type="number"
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item label="可预约地区">
          <el-input
            v-model="formData.area"
            placeholder="如：浙江"
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item label="广告每日显示次数">
          <el-input
            v-model="formData.bannerTimes"
            placeholder="请输入"
            type="number"
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item label="预约间隔时间" prop="appointment_interval">
          <el-select
            v-model="formData.appointment_interval_start"
            placeholder="选择时间"
            style="width: 100px"
            :clearable="false"
            @change="changeAppointmentInterval"
          >
            <el-option
              v-for="item in timeOptions"
              :key="item"
              :label="item + ''"
              :value="item + ''"
            ></el-option>
          </el-select>
          <el-select
            v-model="formData.appointment_interval_end"
            placeholder="选择时间"
            style="width: 100px"
            :clearable="false"
            @change="changeAppointmentInterval"
          >
            <el-option
              v-for="item in timeOptions"
              :key="item"
              :label="item + ''"
              :value="item + ''"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="自由人员分润比例">
          <el-input
            v-model="formData.freeCommission"
            placeholder="请输入"
            type="number"
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item label="服务商分润比例">
          <el-input
            v-model="formData.companyCommission"
            placeholder="请输入"
            type="number"
            size="small"
          ></el-input>
        </el-form-item>
      </div>
      <el-form-item label="接单状态">
        <el-select
          v-model="formData.is_acceptorders"
          placeholder="选择接单状态"
          style="width: 200px"
          :clearable="false"
        >
          <el-option label="禁止接单" value="0"></el-option>
          <el-option label="开启接单" value="1"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div class="el-form-item" style="width: 400px; text-align: center">
      <el-button
        type="primary"
        @click="submitForm('formData')"
        size="small"
        :loading="saving"
      >
        确定
      </el-button>
    </div>
  </div>
</template>

<script>
import { Form as ElForm } from "element-ui";
const timeOptions = [
  "00:00",
  "01:00",
  "02:00",
  "03:00",
  "04:00",
  "05:00",
  "06:00",
  "07:00",
  "08:00",
  "09:00",
  "10:00",
  "11:00",
  "12:00",
  "13:00",
  "14:00",
  "15:00",
  "16:00",
  "17:00",
  "18:00",
  "19:00",
  "20:00",
  "21:00",
  "22:00",
  "23:00",
  "24:00",
];
export default {
  name: "systemConfig",
  components: {},
  data() {
    return {
      timeOptions,
      loading: false,
      saving: false,
      labelPosition: "right",
      AppointmentConfig: {},
      commissionConfig: {},
      isCompany: false,
      formData: {
        freeCommission: "",
        companyCommission: "",
        appointmentTimes: "",
        area: "",
        bannerTimes: "",
        appointment_interval: "",
        appointment_interval_start: "",
        appointment_interval_end: "",
        is_acceptorders: "",
        order_insurance: "",
        lowest_price: "",
      },
    };
  },
  created() {
    this.getTimesList();
    this.getRegionList();
    this.getCodeList();
    this.getUserBannerList();
    this.getAppointmentIntervalList();
    this.getAcceptOrdersList();
    this.getOrderInsurance();
    this.getLowestPrice();
    this.getCommissionList();
    let userInfo = JSON.parse(window.localStorage.getItem("userInfo") || "{}");
    if (userInfo.companyId) {
      this.isCompany = true;
    } else {
      this.isCompany = false;
    }
  },
  methods: {
    changeAppointmentInterval() {
      console.log(
        this.formData.appointment_interval_start,
        this.formData.appointment_interval_end,
      );
      this.formData.appointment_interval =
        this.formData.appointment_interval_start +
        "-" +
        this.formData.appointment_interval_end;
    },
    async getCodeList() {
      let data = await this.$get("/parameter/getDefinitionList");
    },
    async getTimesList() {
      let { list, total } = await this.$get("/parameter/getByCode", {
        definitionCode: "appointment_times",
        pageSize: 10,
        currentPage: 1,
      });
      this.timesConfig = list[0];
      this.formData.appointmentTimes = this.timesConfig.content;
    },
    async getCommissionList() {
      let { list, total } = await this.$get("/parameter/getByCode", {
        definitionCode: "commission",
        pageSize: 10,
        currentPage: 1,
      });
      this.commissionConfig = list[0];
      const [freeCommission, companyCommission] =
        this.commissionConfig.content.split(",");
      this.formData.freeCommission = freeCommission;
      this.formData.companyCommission = companyCommission;
    },
    async getAppointmentIntervalList() {
      let { list, total } = await this.$get("/parameter/getByCode", {
        definitionCode: "appointment_interval",
        pageSize: 10,
        currentPage: 1,
      });
      this.AppointmentConfig = list[0];
      const [start, end] = this.AppointmentConfig.content.split("-");
      this.formData.appointment_interval = this.AppointmentConfig.content;
      this.formData.appointment_interval_start = start + "";
      this.formData.appointment_interval_end = end + "";
      console.log(start === "08:00");
    },
    async getRegionList() {
      let { list, total } = await this.$get("/parameter/getByCode", {
        definitionCode: "region",
        pageSize: 10,
        currentPage: 1,
      });
      this.regionConfig = list[0] || {};
      this.formData.area = this.regionConfig.content || "";
    },
    async getUserBannerList() {
      let { list, total } = await this.$get("/parameter/getByCode", {
        definitionCode: "user_banner_count",
        pageSize: 10,
        currentPage: 1,
      });
      this.bannerConfig = list[0] || {};
      this.formData.bannerTimes = this.bannerConfig.content || "";
    },
    async getOrderInsurance() {
      let { list, total } = await this.$get("/parameter/getByCode", {
        definitionCode: "order_insurance",
        pageSize: 10,
        currentPage: 1,
      });
      this.orderInsuranceConfig = list[0] || {};
      this.formData.order_insurance = this.orderInsuranceConfig.content || "";
    },
    async getLowestPrice() {
      let { list, total } = await this.$get("/parameter/getByCode", {
        definitionCode: "lowest_price",
        pageSize: 10,
        currentPage: 1,
      });
      this.lowestPriceConfig = list[0] || {};
      this.formData.lowest_price = this.lowestPriceConfig.content || "";
    },
    async getAcceptOrdersList() {
      let { list, total } = await this.$get("/parameter/getByCode", {
        definitionCode: "is_acceptorders",
        pageSize: 10,
        currentPage: 1,
      });
      this.acceptOrdersConfig = list[0] || {};
      this.formData.is_acceptorders = this.acceptOrdersConfig.content || "";
    },
    async submitForm(formName) {
      this.saving = true;
      try {
        if (this.formData.appointmentTimes) {
          // 最大预约次数
          let params = {
            ...this.timesConfig,
            content: this.formData.appointmentTimes,
          };
          await this.$get("/parameter/saveParameter", params);
        }
        if (this.formData.area) {
          // 地区限制
          let params = {
            ...this.regionConfig,
            content: this.formData.area,
            name: "地区",
            definitionCode: "region",
            definitionId: 6,
          };
          await this.$get("/parameter/saveParameter", params);
        }
        if (this.formData.bannerTimes) {
          // 地区限制
          let params = {
            ...this.bannerConfig,
            content: this.formData.bannerTimes,
            name: "每天打开广告的次数",
            definitionCode: "user_banner_count",
            definitionId: 7,
          };
          await this.$get("/parameter/saveParameter", params);
        }
        if (this.formData.appointment_interval) {
          let params = {
            ...this.AppointmentConfig,
            content: this.formData.appointment_interval,
            name: "预约间隔时间",
            definitionCode: "appointment_interval",
            definitionId: 8,
          };
          await this.$get("/parameter/saveParameter", params);
        }
        if (
          this.formData.freeCommission !== "" &&
          this.formData.companyCommission !== ""
        ) {
          let params = {
            ...this.commissionConfig,
            content:
              this.formData.freeCommission +
              "," +
              this.formData.companyCommission,
            name: "分润比例",
            definitionCode: "commission",
          };
          await this.$get("/parameter/saveParameter", params);
        }
        if (this.formData.order_insurance !== "") {
          let params = {
            ...this.orderInsuranceConfig,
            content: this.formData.order_insurance,
            name: "订单险价格",
            definitionCode: "order_insurance",
          };
          await this.$get("/parameter/saveParameter", params);
        }
        if (this.formData.lowest_price !== "") {
          let params = {
            ...this.lowestPriceConfig,
            content: this.formData.lowest_price,
            name: "最低价",
            definitionCode: "lowest_price",
          };
          await this.$get("/parameter/saveParameter", params);
        }
        if (this.formData.is_acceptorders !== "") {
          // 接单状态
          let params = {
            ...this.acceptOrdersConfig,
            content: this.formData.is_acceptorders,
            name: "接单状态",
            definitionCode: "is_acceptorders",
            definitionId: 9,
          };
          await this.$get("/parameter/saveParameter", params);
        }
        this.$message({
          type: "success",
          message: "添加成功",
        });
        this.$refs.formData.resetFields();
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.page-add-user {
  height: 100%;
  background: #fff;
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .table-box {
    font-size: 14px;
  }
  .addText {
    width: 500px;
    text-align: center;
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 20px;
  }
  .pages {
    background: #fff;
    margin-top: 10px;
    padding: 10px 10px;
    text-align: right;
    height: 55px;
    box-sizing: border-box;
  }
  .search-box {
    background: #fff;
    margin-bottom: 10px;
    padding: 10px 10px;
    border-radius: 4px;
    height: 55px;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-end;
    .el-input {
      margin-left: 20px;
      width: 300px;
      margin-right: 10px;
    }
  }
  .time-select {
    width: 100px;
    margin-right: 10px;
  }
}
</style>
